import { MatomoProvider } from '@datapunt/matomo-tracker-react';
import { useMemo } from 'react';
import { withIsActiveGuard } from '../../utils';
import { MODULE_NAME } from '../model/constant';
import { getMatomoInstance, getSettings } from '../model/utils';

const MatomoProviderWrapper = ({ children }) => {
  const config = getSettings();
  const matomoInstance = useMemo(() => getMatomoInstance(config), [config]);

  return <MatomoProvider value={matomoInstance}>{children}</MatomoProvider>;
};

export default withIsActiveGuard(MODULE_NAME)(MatomoProviderWrapper);
